export default __webpack_public_path__ + "static/media/Сurtains_device.a9ffc42a.svg";